<!--  -->
<template>
  <div class="handselEntrance" v-show="show" @click="toMyHandsel">
    <p>您有{{ depositList.length }}个待支付定金单，点击查看！</p>
    <van-icon name="arrow" />
  </div>
</template>

<script>
import { reqDepositList } from '@/api/personal/handsel';

export default {
  components: {},
  data() {
    return {
      show: false,
      depositList: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getHandsel() {
      const res = await reqDepositList();
      if (res?.code === 0 && res?.data?.length) {
        this.depositList = res?.data;
        this.show = true;
      }
    },
    toMyHandsel() {
      this.$router.push({
        path: '/personalCenter/myHandsel',
      });
    },
  },
  created() {
    this.getHandsel();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.handselEntrance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 678px;
  height: 74px;
  margin: 22px auto;
  padding: 0 25px;
  background: linear-gradient(145deg, #ff5843 0%, #ff6161 100%);
  border-radius: 14px;
  > p {
    color: #fff;
    font-weight: 500;
    font-size: 22px;
  }
  ::v-deep .van-icon {
    color: #fff;
    font-size: 16px;
  }
}
</style>
